<template>
  <div>
    <section
      id="tab__content2"
      class="tab__content"
      role="tabpanel"
      aria-labelledby="specification"
      aria-hidden="true"
    >
      <div class="tab__content__wrap">
        <div class="section__wrap">
          <div class="section__header">
            <div class="section__title">제출 업체 사업자 번호</div>
          </div>
          <div class="section__body">
            <ul class="common__list">
              <li class="common__item">
                <span class="common__item__name">사업자 번호</span>

                <div class="common__item__desc__wrap">
                  <span class="common__item__desc">{{ formattedBizno }}</span>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="section__wrap">
          <div class="section__header">
            <div class="section__title">업데이트 정보</div>
          </div>
          <div class="section__body">
            <ul class="common__list">
              <li class="common__item">
                <span class="common__item__name">업데이트 정보</span>
                <div class="common__item__desc__wrap">
                  <span class="common__item__desc">{{ updateList }}</span>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="section__wrap">
          <div class="section__header">
            <div class="section__title">약관 동의</div>
          </div>
          <div class="section__body">
            <div class="terms__info">
              <div class="terms__agree__all">
                <input
                  id="check1"
                  v-model="bizInfo.agreeAll"
                  type="checkbox"
                  @change="onChangeAllAgreement"
                />
                <label for="check1">
                  <span class="title">전체동의</span>
                  <span class="point">(필수)</span>
                </label>
              </div>
              <div class="terms__lists">
                <div class="terms__item">
                  <div>
                    <input
                      id="check2"
                      v-model="bizInfo.agree1"
                      type="checkbox"
                      @change="onChangeCheck"
                    />
                    <label for="check2">기업정보 제공 및 활용동의 (필수)</label>
                  </div>
                  <button class="view-term" @click="showCorporatePopup = true">전문보기</button>
                </div>
                <div class="terms__item">
                  <div>
                    <input
                      id="check3"
                      v-model="bizInfo.agree2"
                      type="checkbox"
                      @change="onChangeCheck"
                    />
                    <label for="check3">개인정보 수집 및 이용에 대한 동의 (필수)</label>
                  </div>
                  <button class="view-term" @click="showPrivacyPopup = true">전문보기</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="section__wrap">
          <div class="section__header">
            <div class="section__title">제출 정보</div>
          </div>
          <div class="section__body">
            <ul class="common__list">
              <li class="common__item border-b">
                <span class="common__item__name">인증 방식</span>
                <div class="common__item__desc__wrap">
                  <input id="radio1" type="radio" name="auth" checked />
                  <label for="radio1">휴대폰 인증</label>
                  <!-- 추후 개발 -->
                  <!-- <input id="radio2" type="radio" name="auth" onchange="onChangeAuthMethod(1)" />
                  <label for="radio2">개인 공동인증서 인증</label>
                  <input id="radio3" type="radio" name="auth" onchange="onChangeAuthMethod(2)" />
                  <label for="radio3">사업자 공동인증서 인증</label>-->
                </div>
              </li>
              <div class="common__item__wrap">
                <div class="common__item__input only__input">
                  <label data-v-9bd284cc="" class="input__label" for="name">제출자명</label>
                  <div class="flex">
                    <input
                      id="name"
                      v-model="bizInfo.name"
                      :class="{ error: bizInfo.certiMsg }"
                      type="text"
                      placeholder="이름 입력"
                    />
                  </div>
                  <div v-if="bizInfo.certiMsg" class="error__text">{{ bizInfo.certiMsg }}</div>
                </div>
                <div class="common__item__input only__input">
                  <label data-v-9bd284cc="" class="input__label" for="tel">제출자 휴대전화</label>
                  <div class="flex">
                    <input
                      id="tel"
                      v-model="formattedTel"
                      :class="{ error: bizInfo.certiMsg }"
                      type="text"
                      maxlength="13"
                      placeholder="숫자만 입력"
                      oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');"
                    />
                    <button :class="certiBtnClass" @click="clickCertiButton">
                      {{ certiBtn }}
                    </button>
                  </div>
                </div>
                <!-- 추후 개발 -->
                <!-- <div id="rrno" class="common__item__input only__input">
                  <p class="input__label">주민등록번호</p>
                  <div class="flex">
                    <input type="text" placeholder="숫자만 입력" />
                  </div>
                </div>
                <div id="bizno" class="common__item__input only__input">
                  <p class="input__label">사업자번호</p>
                  <div class="flex">
                    <input type="text" placeholder="숫자만 입력" />
                  </div>
                </div>-->
              </div>
            </ul>
          </div>
        </div>
      </div>
    </section>
    <div v-if="showCorporatePopup" id="popupWrap" class="popup__bg">
      <div id="popup" class="dataline__popup">
        <div class="popup__header">
          <div class="header__wrap">
            <div class="header__title">기업정보 제공 및 활용동의 (필수)</div>
            <div class="header__btn">
              <button class="button icon" @click="showCorporatePopup = false">
                <span class="close" />
              </button>
            </div>
          </div>
        </div>
        <AgreeCorporatePopup></AgreeCorporatePopup>
      </div>
    </div>

    <div v-if="showPrivacyPopup" id="popupWrapPrivary" class="popup__bg">
      <!--  개인정보 수집 및 이용에 대한 동의 -->
      <div id="popupPrivary" class="dataline__popup">
        <div class="popup__header">
          <div class="header__wrap">
            <div class="header__title">개인정보 수집 및 이용에 대한 동의(필수)</div>
            <div class="header__btn">
              <button class="button icon" @click="showPrivacyPopup = false">
                <span class="close" />
              </button>
            </div>
          </div>
        </div>
        <AgreePrivacyPopup></AgreePrivacyPopup>
      </div>
    </div>
    <form
      v-show="false"
      id="checkplusForm"
      ref="form"
      action="https://nice.checkplus.co.kr/CheckPlusSafeModel/checkplus.cb"
      target="datalineCheckplusPopup"
      method="post"
    >
      <input type="hidden" name="m" value="checkplusService" />
      <input v-model="encodeData" type="hidden" name="EncodeData" />
    </form>
  </div>
</template>

<script>
import AgreeCorporatePopup from "../popup/UpdateAgreeCorporatePopup.vue";
import AgreePrivacyPopup from "../popup/UpdateAgreePrivacyPopup.vue";
import { mapGetters } from "vuex";
import { getCheckplusEncodedData } from "@/api/niceApi.js";
import { popupCertification } from "@/utils/commonUtils.js";

export default {
  name: "UpdateRequestAgree",
  components: {
    AgreeCorporatePopup,
    AgreePrivacyPopup,
  },
  data() {
    return {
      showCorporatePopup: false,
      showPrivacyPopup: false,
      m: "checkplusService",
      encodeData: "",
    };
  },
  computed: {
    ...mapGetters(["bizInfo"]),
    formattedBizno() {
      return this.bizInfo.bizno.replace(/(\d{3})(\d{2})(\d{5})/, "$1-$2-$3");
    },
    updateList() {
      const infoTypeList = ["fin1info", "fin2info", "fin3info"];
      let resultList = [];
      if (this.bizInfo.bizinfo.checkStatus == 1)
        resultList.push("사업자등록증명(사업자번호: " + this.formattedBizno + ")");
      infoTypeList.forEach(infoType => {
        if (this.bizInfo[infoType].checkStatus == 1)
          resultList.push("표준재무제표증명(" + this.bizInfo[infoType].checkMsg + ")");
      });
      return resultList.join(", ");
    },
    formattedTel: {
      get() {
        return this.bizInfo.tel.replace(/(\d{3})(\d{3,4})(\d{4})/, "$1-$2-$3");
      },
      set(value) {
        // eslint-disable-next-line no-useless-escape
        value = value.replace(/\-/g, "");
        this.$store.commit("BizInfo/SET_TEL", value);
      },
    },
    certiBtnClass() {
      return {
        button: true,
        square: true,
        primary: this.bizInfo.certiStatus == 0,
        black: this.bizInfo.certiStatus == 1,
      };
    },
    certiBtn() {
      return this.bizInfo.certiStatus == 0 ? "인증" : "재인증";
    },
  },
  methods: {
    onChangeAllAgreement() {
      this.bizInfo.agree1 = this.bizInfo.agreeAll;
      this.bizInfo.agree2 = this.bizInfo.agreeAll;
    },
    onChangeCheck() {
      this.bizInfo.agreeAll = this.bizInfo.agree1 && this.bizInfo.agree2;
    },
    biznoFomatter(num) {
      var formatNum = "";
      formatNum = num.replace(/(\d{3})(\d{2})(\d{5})/, "$1-$2-$3");
      return formatNum;
    },
    clickCertiButton() {
      if (!this.bizInfo.name) {
        this.$store.commit("BizInfo/SET_CRTMSG", "제출자명을 입력해주세요.");
      } else if (!this.validateTel(this.bizInfo.tel)) {
        this.$store.commit("BizInfo/SET_CRTMSG", "제출자 휴대전화를 다시 입력해주세요.");
      } else if (!this.bizInfo.agreeAll) {
        this.$store.commit("BizInfo/SET_CRTMSG", "전체 약관에 동의해주세요.");
      } else {
        this.popupPassCertification();
        this.$store.commit("BizInfo/SET_CRTMSG", "");
        this.$store.commit("BizInfo/SET_CRTSTATUS", 1);
      }
    },
    validateTel(tel) {
      return tel.length >= 10 && tel.length <= 11 && tel.substring(0, 2) == "01";
    },
    async popupPassCertification() {
      const data = await getCheckplusEncodedData();
      this.encodeData = data;
      await this.$nextTick();
      popupCertification("about:blank", "datalineCheckplusPopup");
      document.getElementById("checkplusForm").submit();
    },
  },
};
</script>

<style lang="" scoped></style>
